import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import AgGridTable from "../../utilities/AgGridTable";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.min.css';
// import customStyle from './SummaryGrid.css'
import oAuthServiceConfig from 'src/app/auth/services/oAuthService/oAuthServiceConfig';
import OAuthService from 'src/app/auth/services/oAuthService';
// import { summaryData, report } from "./planActualsData";
import Modal from '@mui/material/Modal';

const processData = (data) => {
    const flattenedData = [];
    const flattenRowRecursive = (row, parentPath) => {
        row['partnerName'] = "Universal Trading Company"
        row["january"] = 0;
        row["february"] = 0;
        row["march"] = 1;
        row["april"] = 0;
        row["may"] = 2;
        row["june"] = 0;
        row["july"] = 0;
        row["august"] = 1;
        row["september"] = 2;
        row["october"] = 0;
        row["november"] = 0;
        row["december"] = 0;
        row["totalDays"] = 6;
        const dataPath = [...parentPath, row.orderCategory];
        flattenedData.push({ ...row, dataPath });
        if (row.subCategories) {
            row.subCategories.forEach((underling) =>
                flattenRowRecursive(underling, dataPath)
            );
        }
    };
    data.forEach((row) => flattenRowRecursive(row, []));
    return flattenedData;
}

const AddAttendeesGrid = (props) => {
    const [open, setOpen] = React.useState(props.showAttendeeList);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [reportData, setReportData] = useState([]);
    const [rowData, setRowData] = useState();
    const [columnDefs, setColumnDefs] = useState([
        { field: "attendeeName", headerName: "Attendee Name", },
        { field: "showroom", headerName: "Showroom", },
        { field: "designation", headerName: "Designation", },
        { field: "emailId", headerName: "Email ID", },
        { field: "phoneNo", headerName: "Phone No.", },
        { field: "nine", headerName: "19 Jan", },
        { field: "twenty", headerName: "20 Jan", },
    ]);

    const gridRef = useRef();
    const [stateData, setStateData] = useState({ filter: '', columnState: '', columnGroupState: '' });

    const autoSizeAll = useCallback(
        (value) => {
            const allColumnIds = [];
            props.gridRef.current.columnApi.getColumns().forEach((column) => {
                allColumnIds.push(column?.getId());
            });
            props.gridRef.current.columnApi.autoSizeColumns(allColumnIds, value);
        },
        [rowData]
    );

    const onGridReady = useCallback((params) => {
        // setRowData(processData(props.rowData));
        autoSizeAll(false);
    }, []);

    const onColumnStateChanged = (params) => {
        stateData.columnState = params?.columnApi?.getColumnState();
        stateData.columnGroupState = params?.columnApi?.getColumnGroupState();
    }

    return (
        <>
                <div style={{ height: 400 }}>
                    <AgGridTable
                        rowData={rowData}
                        columnDefs={columnDefs}
                        onGridReady={onGridReady}
                        gridRef={gridRef}
                        hideCheckbox={true}
                        editable={false}
                        pagination={false}
                        showSidebar={false}
                        rowGroupPanelShow={'hide'}
                    />
                </div>
        </>
    )
};

export default AddAttendeesGrid;